/**
 * Returns true when verifyPhone should use challengeId + phoneNumber only.
 * Applies to passwordless email login and email/password login with risk OTP verification.
 */
export const usesChallengeBasedPhoneVerification = (
  phoneVerificationRequired,
  loginOtpChallenge
) => phoneVerificationRequired === true && loginOtpChallenge != null;
